import { useSelector } from "react-redux";
import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import { isNonNullish } from "../../../abstract/controller/utils/systemUtils";
import useNodeTraversal from "../../../abstract/hook/useNodeTraversal";
import { getIsFolded } from "../../../abstract/redux/slice/metaSlice";
import ChoicePanel from "../choice/ChoicePanel";
import ChoiceStructure from "../choice/structure/ChoiceStructure";
import styles from "./ChildrenChoice.module.scss";

const getId = (e) => {
  return e.name === "" ? Date.now() : e.id;
};

function ChildrenChoice({ node, readOnly = false, forceView = false }) {
  const _id = nodeUtils.getID(node);
  const _uuid = nodeUtils.getUUID(node);
  const nodeTarget = useNodeTraversal(_id);

  const _isFolded = useSelector(getIsFolded(_uuid));

  if (_isFolded && !readOnly) {
    return null;
  }

  const hasChoices = nodeUtils.hasChoices(nodeTarget);

  if (!hasChoices && !forceView) {
    return null;
  }

  const target = nodeUtils.getIdTarget(node);
  const defaultValue = nodeUtils.getValueDefault(node);
  const parsedReadOnly = readOnly || target || isNonNullish(defaultValue);

  const choices = nodeUtils.getChoices(nodeTarget);

  return (
    <div className={`${styles["children"]} ${parsedReadOnly ? styles["children--readOnly"] : ""}`}>
      {forceView && !hasChoices && <div className={`${styles["children__text"]}`}>Empty.</div>}
      {choices.map((e) => (
        <ChoiceStructure key={getId(e)} id={e.id} readOnly={parsedReadOnly} />
      ))}
      {!parsedReadOnly && (
        <div className={`${styles["children__panel"]}`}>
          <ChoicePanel  node={node} forceIsTop={true} />
        </div>
      )}
    </div>
  );
}

export default ChildrenChoice;
